/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SaveOfRepostNotificationActionData } from './SaveOfRepostNotificationActionData';
import {
    SaveOfRepostNotificationActionDataFromJSON,
    SaveOfRepostNotificationActionDataFromJSONTyped,
    SaveOfRepostNotificationActionDataToJSON,
} from './SaveOfRepostNotificationActionData';

/**
 * 
 * @export
 * @interface SaveOfRepostNotificationAction
 */
export interface SaveOfRepostNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof SaveOfRepostNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof SaveOfRepostNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof SaveOfRepostNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {SaveOfRepostNotificationActionData}
     * @memberof SaveOfRepostNotificationAction
     */
    data: SaveOfRepostNotificationActionData;
}

/**
 * Check if a given object implements the SaveOfRepostNotificationAction interface.
 */
export function instanceOfSaveOfRepostNotificationAction(value: object): value is SaveOfRepostNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function SaveOfRepostNotificationActionFromJSON(json: any): SaveOfRepostNotificationAction {
    return SaveOfRepostNotificationActionFromJSONTyped(json, false);
}

export function SaveOfRepostNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveOfRepostNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': SaveOfRepostNotificationActionDataFromJSON(json['data']),
    };
}

export function SaveOfRepostNotificationActionToJSON(value?: SaveOfRepostNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': SaveOfRepostNotificationActionDataToJSON(value.data),
    };
}

